var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundPinkTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66406C5.4013 1.66406 1.66797 5.3974 1.66797 9.9974C1.66797 14.5974 5.4013 18.3307 10.0013 18.3307C14.6013 18.3307 18.3346 14.5974 18.3346 9.9974C18.3346 5.3974 14.6013 1.66406 10.0013 1.66406ZM10.0013 16.6641C6.3263 16.6641 3.33464 13.6724 3.33464 9.9974C3.33464 6.3224 6.3263 3.33073 10.0013 3.33073C13.6763 3.33073 16.668 6.3224 16.668 9.9974C16.668 13.6724 13.6763 16.6641 10.0013 16.6641ZM13.8263 6.31406L8.33464 11.8057L6.1763 9.65573L5.0013 10.8307L8.33464 14.1641L15.0013 7.4974L13.8263 6.31406Z",
    fill: "#EB008D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPinkTick);
export default __webpack_public_path__ + "static/media/RoundPinkTick.92f6718714f3aa12f14ef4252efd59c7.svg";
export { ForwardRef as ReactComponent };